import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { AppIcons } from "../constants/app-icons";
import { Core } from "../helpers/core";
export default class ReturnItemService extends ApiService {
  namespace = "returnItem";
  template = "defaultTemplate";
  fullWindow = false;
  icon = "Wallet";
  DOMAIN = 200;
  data = [];
  favicon = "Bullets";
  name = "Return Items";
  singular = this.terminology.returnItem.singular;
  plural = this.terminology.returnItem.plural;
  vowel = this.terminology.returnItem.vowel;
  action = "action";
  layout = 2;
  Width = 1500;
  gemItems = [
    {
      key: "listing",
      label: "All Return Items",
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add a Return Item",
      icon: AppIcons.PLUS,
    },
    {
      key: "create",
      label: "Settings",
      services: -39,
      icon: AppIcons.BULLETS,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      width: "5",
    },
    {
      header: this.t("items"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      width: "5",
      template: (data) => {
        return Core.datey(data.date);
      },
    },
    {
      header: this.t("due"),
      icon: AppIcons.LIGHTNING,
      field: "due_date",
      width: "5",
    },

    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "amount",
      width: "5",
    },

    {
      header: this.t("received"),
      icon: AppIcons.MONEY,
      field: "received",
      width: "5",
    },
    {
      header: this.t("balance"),
      icon: AppIcons.MONEY,
      field: "balanace",
      width: "5",
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "5",
    },
    {
      header: this.t("PO"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "5",
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Edit this Invoice...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: -3,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];

  constructor() {
    super("return-items");
  }
}
